<template>
  <section class="tad-card">
    <header v-if="title || icon || $slots.header" class="tad-card__header">
      <v-icon v-if="icon" :icon="icon" size="18" class="tad-card__icon" />
      <h3 v-if="title" class="tad-card__title">{{ title }}</h3>
      <slot name="header" />
    </header>
    <div class="tad-card__body">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: "TicketActionCard",
  props: {
    title: { type: String, default: "" },
    icon: { type: String, default: "" },
  },
};
</script>
